// ------------------------------------------------------------------------------
// name: activity
// author: mudas
// created: 2025/9/10
// ------------------------------------------------------------------------------

import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import {
  ActivityDetail,
  ActivityListItem,
  ActivityListParams,
  CreateActivityParams,
  IPaginationParams,
  PaginationResult,
  EditActivityParams,
} from 'common/types';

// --------------------------------------------------------------------------
//
// 列表和详情
//
// --------------------------------------------------------------------------

export const getActivityList = (params: IPaginationParams<ActivityListParams>) => {
  return FastApiAxiosInstance.get<PaginationResult<ActivityListItem>>('/api/v1/backend/activity/list', {
    params,
  });
};

export const getActivityDetail = (params: { id: number }) => {
  return FastApiAxiosInstance.get<ActivityDetail>('/api/v1/backend/activity/details', { params });
};

// --------------------------------------------------------------------------
//
// 统计和其它操作
//
// --------------------------------------------------------------------------

export const createActivity = (params: CreateActivityParams) => {
  return FastApiAxiosInstance.post('/api/v1/backend/activity/create', params);
};

export const editActivity = (params: EditActivityParams) => {
  return FastApiAxiosInstance.post('/api/v1/backend/activity/edit', params);
};
